/**
 * ============================================================================
 * EnrollNowSticky (MVC feature barrel)
 * ============================================================================
 * Public entry kept at EnrollNowSticky.tsx so layout-dynamic import stays
 * stable.
 * ============================================================================
 */
"use client";

import { SectionErrorBoundary } from "@/components/common/ErrorBoundary";
import { useEnrollNowStickyController } from "./controller/useEnrollNowStickyController";
import EnrollNowStickyView from "./view/EnrollNowStickyView";
import type { EnrollNowStickyProps } from "./model/enrollNowSticky.types";

export type {
  EnrollNowStickyProps,
  EnrollNowStickyViewModel,
} from "./model/enrollNowSticky.types";

function EnrollNowStickyInner(props: EnrollNowStickyProps) {
  const viewModel = useEnrollNowStickyController(props);
  if (!viewModel) return null;
  return <EnrollNowStickyView {...viewModel} />;
}

export default function EnrollNowSticky(props: EnrollNowStickyProps) {
  return (
    <SectionErrorBoundary sectionName="EnrollNowSticky">
      <EnrollNowStickyInner {...props} />
    </SectionErrorBoundary>
  );
}
